module.exports = __webpack_public_path__ + "media/images/jobs/jobs-guide-en-e85b3e7baf5e2925698158aa7e0a1a30.jpg";